import { Clickable } from '@carvana/vdp-components';
import { useContext } from 'react';
import {
  getPurchaseStatus,
  useGreatDealTag
} from '@/SearchResults/ResultTileV2/helpers/ResultTile.helpers';
import MoreDetailsModalSections from '~/constants/MoreDetailsModalSections';
import ModalContext from '~/contexts/ModalContext';
import { useTileDataContext } from '~/contexts/TileDataContext';
import Tag from './Tag';

const GreatDealTag = () => {
  const { tileData } = useTileDataContext();
  const { setMoreDetailsModalOpen } = useContext(ModalContext);
  const { isLocked, isOnHold } = getPurchaseStatus(tileData);
  const greatDeal = useGreatDealTag(tileData);

  if (
    isLocked ||
    isOnHold ||
    tileData?.vehiclePurchaseType === 'Reservable' ||
    greatDeal == null
  ) {
    return null;
  }

  return (
    <Clickable
      data-analytics-id="open-result-tile-modal"
      data-analytics-attributes={JSON.stringify({
        clickedSource: 'Great deal tag'
      })}
      className="pointer-events-auto"
      data-qa="great-deal-badge"
      onClick={e => {
        e.preventDefault();
        setMoreDetailsModalOpen(true, {
          openTo: MoreDetailsModalSections.GreatDeal,
          vehicle: tileData
        });
      }}
    >
      <Tag text={greatDeal.tagName} bgColor="bg-blue-4" />
    </Clickable>
  );
};

export default GreatDealTag;
